<template>
  <v-container>
    <list-net v-if="choosenNetwork==null" @choosennetwork="showChoosenNetwork"></list-net>
    <devices
      v-if="choosenAlert==null && choosenNetwork!=null && choosenDevice==null"
      @choosendevice="showChoosenDevice"
      :networkId="choosenNetwork.networkId"
      :network="choosenNetwork"
      @back="back"
      :create="create"
      @create="goToCreate"
      @stopcreate="backNetwork"
    ></devices>
    <show-d
      v-if="choosenAlert==null && choosenNetwork!=null && choosenDevice!=null"
      :device="choosenDevice"
      @backnetwork="backNetwork"
      @updateAlert="updateAlert"
      @createAlert="createAlert"
    ></show-d>
    <setalert
      v-if="choosenAlert!=null && choosenNetwork!=null && choosenDevice!=null"
      :deviceAlert="choosenAlert"
      :choosenDevice="choosenDevice"
      :create="createAlertBool"
      @saved="alertSaved"
      @back="backManage"
    ></setalert>
  </v-container>
</template>

<script>
import ListNetworksComponent from "./ListNetworks";
import DevicesComponent from "./Devices";
import ShowDeviceComponent from "./ShowDevice";
import SetDeviceAlertComponent from "./SetDeviceAlert";

import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  components: {
    "list-net": ListNetworksComponent,
    devices: DevicesComponent,
    "show-d": ShowDeviceComponent,
    setalert: SetDeviceAlertComponent,
  },
  props: {
    changedPath: String,
  },
  data: () => ({
    choosenNetwork: null,
    choosenDevice: null,
    choosenAlert: null,
    create: false,
    createAlertBool: false,
  }),
  watch: {
    changedPath: function (value) {
      this.createAlertBool = false;
      if (value == "dataHome") {
        this.choosenDevice = null;
        this.back();
      } else if (value == "device") {
        this.backManage();
      } else if (value == "network") this.backNetwork();
      else {
        try {
          let device = JSON.parse(value);
          if (device.id != null && device.networkId != null) {
            axios
              .get(process.env.VUE_APP_API_ADDR + "/api/user/@me", {
                headers: { Authorization: tokenStore.getToken() },
              })
              .then((res) => {
                let $networks = res.data.user.permissions.networks;
                let i = $networks.findIndex((network) => {
                  return network.networkId == device.networkId;
                });
                let network = $networks[i];
                axios
                  .get(
                    process.env.VUE_APP_API_ADDR +
                      "/api/network/" +
                      network.networkId,
                    {
                      headers: { Authorization: tokenStore.getToken() },
                    }
                  )
                  .then((res) => {
                    network.name = res.data.network.name;
                    network.description = res.data.network.description;
                    this.showChoosenNetwork($networks[i]);
                    this.showChoosenDevice(device);
                  })

                  .catch((err) => {
                    console.log(err);
                    tokenStore.refreshToken();
                  });
              })
              .catch((err) => {
                console.log(err);
                tokenStore.refreshToken();
              });
          }
        } catch (e) {
          //
        }
      }
    },
  },
  mounted(){
              window.scrollTo(0, 0);
  },
  methods: {
    updateAlert(alert) {
      this.choosenAlert = alert;
      this.createAlertBool = false;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "Device (" + this.choosenDevice.name + ")", subpath: "device" },
        {
          name: "Alert (" + alert.name + ")",
          subpath: "updateAlert",
        },
      ]);
    },
    createAlert() {
      this.choosenAlert = {};
      this.createAlertBool = true;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "Device (" + this.choosenDevice.name + ")", subpath: "device" },
        {
          name: this.$t("DataHome.createDeviceAlert"),
          subpath: "createAlert",
        },
      ]);
    },
    backManage: function () {
      this.choosenAlert = null;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "Device (" + this.choosenDevice.name + ")", subpath: "device" },
      ]);
    },
    alertSaved: function () {
      this.choosenAlert = null;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "Device (" + this.choosenDevice.name + ")", subpath: "device" },
      ]);
    },
    goToCreate: function () {
      this.create = true;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "create", subpath: "create" },
      ]);
    },
    showChoosenNetwork: function (value) {
      this.choosenNetwork = value;
      this.title = null;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
      ]);
    },
    showChoosenDevice: function (value) {
      this.choosenDevice = value;
      this.title = null;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
        { name: "Device (" + this.choosenDevice.name + ")", subpath: "device" },
      ]);
    },
    back: function () {
      this.choosenAlert = null;
      this.title = "Please select a network";
      this.create = false;
      this.createAlertBool = false;
      this.choosenNetwork = null;
      this.$emit("subpath", [""]);
    },
    backNetwork: function () {
      this.choosenAlert = null;
      this.choosenDevice = null;
      this.create = false;
      this.createAlertBool = false;
      this.$emit("subpath", [
        {
          name: "Network (" + this.choosenNetwork.name + ")",
          subpath: "network",
        },
      ]);
    },
  },
};
</script>
